const DEFAULT_MIN_LENGTH = 2

export interface FaqSearchFields {
  query: string | null
}

export default class SupportValidator {
  private fields: Partial<FaqSearchFields>

  constructor(fields: Partial<FaqSearchFields>) {
    this.fields = fields
  }

  isQueryLengthValid(): boolean {
    // 2文字以上
    return !!this.fields.query && this.fields.query.length >= DEFAULT_MIN_LENGTH
  }
}
